import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom'
import { StyledFooter } from './StyledFooter';
import { useDispatch } from "react-redux";
import {
  setLoader,
} from "../../redux/loader/loader.actions";
const Footer = ({ children}) => {

  let history = useHistory();
  const dispatch = useDispatch();
  const handleCLick = (slug) => {
    
    if(history.location.pathname !== slug){
      dispatch(setLoader(true))
      
      setTimeout(() =>{ 
        document.body.scrollTop = 0;
        history.push(slug)
      }, 500);
    }
    
  }

  useEffect(() => {
    const year = new Date().getFullYear();
    document.querySelector('#copy-year').innerHTML = year
  },[])
  return (
    <React.Fragment>
      {
        <StyledFooter>
          <div className="footer--map-wrap with--border">
            <div className="footer--map-col">
              <p className="preset-12 link" onClick={() => handleCLick('/company')}>Company</p>
              <p className="preset-12 link" onClick={() => handleCLick('/careers')}>Careers</p>
              <p className="preset-12 link" onClick={() => handleCLick('/investors')}>Investors</p>
              <p className="preset-12 link" onClick={() => handleCLick('/tech')}>Tech</p>
            </div>
            <div className="footer--map-col">
              
              <p className="preset-12 link" onClick={() => handleCLick('/advisors')}>Advisors</p>
              <p className="preset-12 link" onClick={() => handleCLick('/contact-us')}>Contact us</p>
            </div>
            <div className="footer--map-col">
            <p className="preset-12 link"><a href="https://www.iubenda.com/privacy-policy/45668862/cookie-policy" target="_blank" className="footer--external-link">Cookie policy</a></p>

              <p className="preset-12 link"><a href="https://www.iubenda.com/privacy-policy/45668862" target="_blank" className="footer--external-link">Privacy policy</a></p>
            </div>
            <div className="footer--logo-col" >
              <img className="footer-badge" src="/logo-footer.png" />
              <img src="/logo-idc.jpg" />
            </div>
          </div>
          <div className="footer--map-wrap addresses-row">
            <div className="footer--map-col">
              <p className="preset-12 footer-address">Italian HQ</p>
              <p className="preset-13 footer-address no-margin-mobile">
                INVRSION TECHNOLOGIES s.r.l. s.u.<br/>
                Sede: Milano - cap. 20124 -<br/>
                Via Francesco Restelli n° 1
              </p>
              <p className="preset-13 no-margin-mobile">
                Codice fiscale 13090640965<br/>
                P.IVA IT13090640965<br/>
                PEC: invrsion@pec.invrsion.com<br/>
              </p>
            </div>
            
            
            <div className="footer--map-col">
            <br className="show-mobile" />
              <p className="preset-12 footer-address">Subsidiary company</p>
              <p className="preset-13 footer-address">
                INVRSION USA, Inc. - <br/>
                444 Madison Avenue, Suite 1206 - <br/>
                New York, NY 10022<br/>
              </p>
            </div>
          </div>
          <div className="footer--row-wrap">
            <div className="footer--row-col">
              <p>&copy; Copyright <span id='copy-year'></span> | INVRSION TECHNOLOGIES s.r.l. s.u. | All Rights Reserved</p>
            </div>
            <div className="footer--row-col">
              <div className="footer--row-col__mobile">
                <div className="footer--row-col__image">
                  <a href="https://www.crunchbase.com/organization/invrsion" target="_blank">
                    <img src="/crunchbase.svg" />
                  </a>
                </div>
              </div>
              <div className="footer--row-col__mobile footer--social">
                <div className="footer--row-col__image">
                  <a href="https://twitter.com/invrsion" target="_blank">
                    <img src="/icon-twitter.svg" />
                  </a>
                </div>
                <div className="footer--row-col__image">
                  <a href="https://www.facebook.com/invrsion" target="_blank">
                    <img src="/icon-facebook.svg" />
                  </a>
                </div>
                <div className="footer--row-col__image">
                  <a href="https://www.youtube.com/channel/UC9gpb5UYvVnANxx3VCYOjsg" target="_blank">
                    <img src="/icon-youtube.svg" />
                  </a>
                </div>
                <div className="footer--row-col__image">
                  <a href="https://www.linkedin.com/company/invrsion" target="_blank">
                    <img src="/icon-linkedin.svg" />
                  </a>
                </div>
                <div className="footer--row-col__image">
                  <a href="mailto:invrsion@invrsion.com?subject=Contact from invrsion.com" target="_blank">
                    <img src="/icon-email.svg" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          
        </StyledFooter>
         
      }
    </React.Fragment>
  );
};

export default Footer;
